<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="page-title">
        <h1>{{ page_title }}</h1>
        @if (!is_rrhh_view()) {
          <div [matTooltip]="clockStatus() ? 'Solo podrás solicitar una ausencia cuando fiches salida.' : ''">
            <button mat-flat-button color="accent" [routerLink]="['create']" [disabled]="clockStatus()">Crear baja o permiso</button>
          </div>
        } @else if (can_create_absence_as_admin()) {
          <button mat-flat-button color="accent" [routerLink]="['create']">Crear baja o permiso</button>
        }
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="bisual-table">
        <form class="card paginator" [formGroup]="filterForm">
          <mat-paginator
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [pageIndex]="pageIndex"
            (page)="changePage($event)"
            style="margin-right: auto"
          ></mat-paginator>
          @if (is_rrhh_view() && is_rrhh_or_admin()) {
            <mat-form-field style="margin-right: 10px; min-width: 150px">
              <mat-label>Responsable</mat-label>
              <mat-select formControlName="responsible_user_id">
                <mat-option [value]="''">Todas</mat-option>
                <mat-option [value]="currentUserId">Las que gestiono yo</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-right: 10px; min-width: 150px">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="status">
                @for (status of '' | absenceRequestStatuses; track status.value) {
                  <mat-option [value]="status.value">{{ status.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <mat-form-field>
            <input matInput type="text" formControlName="search" placeholder="Buscar..." />
            <button matSuffix mat-icon-button aria-label="Search">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </form>

        <div class="bisual-table-container">
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef>Solicitante</th>
              <td mat-cell *matCellDef="let item">{{ item.user.name }} {{ item.user.surnames }}</td>
            </ng-container>

            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef>Categoría</th>
              <td mat-cell *matCellDef="let item">
                {{ item.working_time_category.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="date_range">
              <th mat-header-cell *matHeaderCellDef>Período</th>
              <td mat-cell *matCellDef="let item">
                @if (item.period_starts_and_ends_at_same_day) {
                  @if (item.is_all_day) {
                    {{ item.start_date | date: 'dd/MM/yyyy' }}
                  } @else {
                    {{ item.start_date | date: 'dd/MM/yyyy HH:mm' }} - {{ item.end_date | date: 'HH:mm' }}
                  }
                } @else {
                  {{ item.start_date | date: 'dd/MM/yyyy' }} - {{ item.end_date | date: 'dd/MM/yyyy' }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="justification">
              <th mat-header-cell *matHeaderCellDef>Justificación</th>
              <td mat-cell *matCellDef="let item">
                <span [matTooltip]="item.justification">
                  {{ item.justification_truncated }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let item">
                <span [class]="'status-badge status-' + item.status" [matTooltip]="item.status_info">
                  {{ item.status_label }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="document">
              <th mat-header-cell *matHeaderCellDef>Documento</th>
              <td mat-cell *matCellDef="let item" class="document-status">
                @if (item.requires_justification || item.document) {
                  @if (item.document) {
                    <mat-icon class="document-icon document-attached" matTooltip="Documento adjunto">check_circle</mat-icon>
                  } @else {
                    <mat-icon class="document-icon document-missing" matTooltip="Sin documento">cancel</mat-icon>
                  }
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let item">
                <div class="actions-cell">
                  <button mat-icon-button (click)="openApprovalStatusDialog(item)" matTooltip="Estado de aprobación">
                    <mat-icon>info</mat-icon>
                  </button>
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>
                <mat-menu #menu="matMenu">
                  @if (item.working_time_category_id) {
                    <button mat-menu-item (click)="openCategoriesLegend(item.working_time_category_id)">
                      <mat-icon style="margin-right: 10px">info</mat-icon>
                      Ver condiciones de categoría
                    </button>
                  }

                  @if (item.document) {
                    <button mat-menu-item (click)="downloadDocument(item.document.id)">
                      <mat-icon style="margin-right: 10px">file_download</mat-icon>
                      Descargar documento
                    </button>
                  }
                  @if (!is_rrhh_view()) {
                    <button mat-menu-item (click)="updateAbsenceRequest(item.id)">
                      <mat-icon style="margin-right: 10px">upload_file</mat-icon>
                      Añadir documentación
                    </button>
                    @if (item.status === EmployeeRequestResponsibleForAnswerStatusEnum.PENDING) {
                      @if (canDeleteAbsenceRequest(item)) {
                        <button mat-menu-item (click)="deleteAbsenceRequest(item.id)">
                          <mat-icon style="margin-right: 10px; color: #e53935">delete</mat-icon>
                          Eliminar solicitud
                        </button>
                      }
                    } @else if (item.status === EmployeeRequestResponsibleForAnswerStatusEnum.ACCEPTED) {
                      @if (canModifyAbsenceRequest(item)) {
                        <button mat-menu-item type="button" (click)="goToModify(item)">
                          <mat-icon style="margin-right: 10px">edit</mat-icon>
                          Solicitar modificación
                        </button>
                      }
                    }
                  } @else if (is_rrhh_view()) {
                    @if (item.status === EmployeeRequestResponsibleForAnswerStatusEnum.PENDING) {
                      <button mat-menu-item (click)="approveAbsenceRequest(item.id)">
                        <mat-icon style="margin-right: 10px">check_circle</mat-icon>
                        Aprobar solicitud
                      </button>
                      <button mat-menu-item (click)="rejectAbsenceRequest(item.id)">
                        <mat-icon style="margin-right: 10px">highlight_off</mat-icon>
                        Rechazar solicitud
                      </button>
                    }
                    @if (canModifyAbsenceRequest(item)) {
                      <button mat-menu-item type="button" (click)="goToModify(item)">
                        <mat-icon style="margin-right: 10px">edit</mat-icon>
                        Modificar
                      </button>
                    }
                    @if (canDeleteAbsenceRequest(item)) {
                      <button mat-menu-item (click)="deleteAbsenceRequest(item.id)">
                        <mat-icon style="margin-right: 10px; color: #e53935">delete</mat-icon>
                        Eliminar solicitud
                      </button>
                    }
                  }
                </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
